@if (loginType) {
    <div class="login">
        <h1 class="sr-only">{{ 'Login' | translate }}</h1>
        <div class="login__content">
            <core-brand-logo category="LOGIN"></core-brand-logo>
            <div class="login__wrapper">
                @if (client.getLoginTitle()) {
                    <h2 class="mb-2">
                        {{ client.getLoginTitle() }}
                        <core-dark-mode-toggle [moonDark]="true" class="float-end"></core-dark-mode-toggle>
                    </h2>
                }
                <p [innerHtml]="client.getLoginWelcomeText()"></p>
                @if (errorMessage) {
                    <div [innerHtml]="errorMessage" class="alert alert-danger"></div>
                }
                @if (successMessage) {
                    <div [innerHtml]="successMessage" class="alert alert-success"></div>
                }

                @if (loginBulletin?.text) {
                    <div class="login__bulletin">
                        <p [innerText]="loginBulletin?.text" class="login__bulletin-text"></p>
                        @if (loginBulletin?.linkHref && loginBulletin?.linkText) {
                            <a
                                [core-analytics]="{ action: 'Bulletin', category: 'LOGIN' }"
                                [href]="loginBulletin?.linkHref"
                                [innerText]="loginBulletin?.linkText"
                                class="btn btn--outline-black btn--register mb-0"></a>
                        }
                    </div>
                }

                @switch (loginType) {
                    @default {
                        <form (ngSubmit)="login()" [formGroup]="loginForm">
                            @if (loginType !== 'generic') {
                                <div
                                    [ngClass]="{
                                        'form-group--success': loginForm.get('username')!.valid,
                                        'form-group--error':
                                            loginForm.get('username')!.touched && !loginForm.get('username')!.valid,
                                    }"
                                    class="form-group">
                                    <div class="form-control-wrapper">
                                        <label class="form-label" for="email">{{ 'Email address' | translate }}</label>
                                        <div class="form-control-wrapper">
                                            <input
                                                class="form-control form-control-lg"
                                                formControlName="username"
                                                id="email"
                                                name="username"
                                                type="email" />
                                            <span
                                                [hidden]="
                                                    loginForm.get('password')!.untouched ||
                                                    loginForm.get('username')!.valid
                                                "
                                                aria-live="polite"
                                                class="invalid-feedback form-control-feedback">
                                                <span class="sr-only">{{ 'Incorrect' | translate }}</span>
                                            </span>
                                            <span
                                                [hidden]="!loginForm.get('username')!.valid"
                                                aria-live="polite"
                                                class="valid-feedback form-control-feedback">
                                                <span class="sr-only">{{ 'Correct' | translate }}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div
                                [ngClass]="{
                                    'form-group--success': loginForm.get('password')!.valid,
                                    'form-group--error':
                                        loginForm.get('password')!.touched && !loginForm.get('password')!.valid,
                                }"
                                class="form-group">
                                <label class="form-label" for="password">{{ 'Password' | translate }}</label>
                                <div class="form-control-wrapper form-control-wrapper--password">
                                    <input
                                        class="form-control form-control-lg"
                                        formControlName="password"
                                        id="password"
                                        name="password"
                                        type="{{ passwordType }}" />
                                    <span
                                        [hidden]="
                                            loginForm.get('password')!.untouched || loginForm.get('password')!.valid
                                        "
                                        aria-live="polite"
                                        class="invalid-feedback form-control-feedback">
                                        <span class="sr-only">{{ 'Incorrect' | translate }}</span>
                                    </span>
                                    <span
                                        [hidden]="!loginForm.get('password')!.valid"
                                        aria-live="polite"
                                        class="valid-feedback form-control-feedback">
                                        <span class="sr-only">{{ 'Correct' | translate }}</span>
                                    </span>
                                </div>
                                <button
                                    (click)="togglePasswordType()"
                                    [core-analytics]="{ action: 'Toggle password type', category: 'LOGIN' }"
                                    [ngClass]="{ 'btn-show-active': passwordType === 'text' }"
                                    class="btn btn-show"
                                    tabindex="-1"
                                    type="button">
                                    {{ 'Toggle to show/hide password' | translate }}
                                </button>
                            </div>
                            <div class="row no-gutters mb-3">
                                <div class="col-12 p-0">
                                    <button
                                        [class.spinner]="loading"
                                        [core-analytics]="{ action: 'Login', category: 'LOGIN' }"
                                        [disabled]="loading || !loginForm.valid"
                                        class="btn btn-primary w-100 btn--login float-end"
                                        type="submit">
                                        @if (loading) {
                                            <span
                                                aria-hidden="true"
                                                class="spinner-grow spinner-grow-sm"
                                                role="status"></span>
                                            <span class="visually-hidden">Logging in...</span>
                                        }
                                        <span [hidden]="loading">{{ 'Login' | translate }}</span>
                                    </button>
                                </div>

                                @if (loginType === 'individual' || loginType === 'mixed') {
                                    <div class="col-12 p-0 pt-2">
                                        <a
                                            [core-analytics]="{ action: 'Reset password', category: 'LOGIN' }"
                                            class="login-link"
                                            routerLink="/reset">
                                            {{ 'Reset password?' | translate }}
                                        </a>
                                    </div>
                                }
                            </div>
                            @if (loginType !== 'generic') {
                                <hr class="login-divider" />
                                <div class="login__register-row">
                                    <p class="register-no-account">{{ "Don't have an account?" | translate }}</p>
                                    <a
                                        [core-analytics]="{ action: 'Register', category: 'LOGIN' }"
                                        class="btn btn--outline-black btn--register mb-0"
                                        routerLink="/register"
                                        >{{ 'Create an account' | translate }}</a
                                    >
                                </div>
                                <!--              <a [core-analytics]="{action: 'Need help', category: 'LOGIN'}" class="login-link"-->
                                <!--                 routerLink="/login-faqs"-->
                                <!--              >{{ 'Need help?' | translate }}</a>-->
                            }
                        </form>
                    }
                    @case ('generic-with-username') {
                        <form (ngSubmit)="login()" [formGroup]="loginForm">
                            <div class="form-group">
                                <label class="form-label" for="generic-username">{{ 'Username' | translate }}</label>
                                <div class="form-control-wrapper">
                                    <!-- Display-only field: the API flow authenticates with the password alone. -->
                                    <input
                                        autocomplete="username"
                                        class="form-control form-control-lg"
                                        id="generic-username"
                                        name="generic-username"
                                        type="text" />
                                </div>
                            </div>
                            <div
                                [ngClass]="{
                                    'form-group--success': loginForm.get('password')!.valid,
                                    'form-group--error':
                                        loginForm.get('password')!.touched && !loginForm.get('password')!.valid,
                                }"
                                class="form-group">
                                <label class="form-label" for="generic-password">{{ 'Password' | translate }}</label>
                                <div class="form-control-wrapper form-control-wrapper--password">
                                    <input
                                        class="form-control form-control-lg"
                                        formControlName="password"
                                        id="generic-password"
                                        name="password"
                                        type="{{ passwordType }}" />
                                    <span
                                        [hidden]="
                                            loginForm.get('password')!.untouched || loginForm.get('password')!.valid
                                        "
                                        aria-live="polite"
                                        class="invalid-feedback form-control-feedback">
                                        <span class="sr-only">{{ 'Incorrect' | translate }}</span>
                                    </span>
                                    <span
                                        [hidden]="!loginForm.get('password')!.valid"
                                        aria-live="polite"
                                        class="valid-feedback form-control-feedback">
                                        <span class="sr-only">{{ 'Correct' | translate }}</span>
                                    </span>
                                </div>
                                <button
                                    (click)="togglePasswordType()"
                                    [core-analytics]="{ action: 'Toggle password type', category: 'LOGIN' }"
                                    [ngClass]="{ 'btn-show-active': passwordType === 'text' }"
                                    class="btn btn-show"
                                    tabindex="-1"
                                    type="button">
                                    {{ 'Toggle to show/hide password' | translate }}
                                </button>
                            </div>
                            <div class="row no-gutters mb-3">
                                <div class="col-12 p-0">
                                    <button
                                        [class.spinner]="loading"
                                        [core-analytics]="{ action: 'Login', category: 'LOGIN' }"
                                        [disabled]="loading || !loginForm.valid"
                                        class="btn btn-primary w-100 btn--login float-end"
                                        type="submit">
                                        @if (loading) {
                                            <span
                                                aria-hidden="true"
                                                class="spinner-grow spinner-grow-sm"
                                                role="status"></span>
                                            <span class="visually-hidden">Logging in...</span>
                                        }
                                        <span [hidden]="loading">{{ 'Login' | translate }}</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    }
                    @case ('individual-managed') {
                        @if (managedPage$ | async; as managedPage) {
                            @if (managedPage) {
                                <div class="row individual-managed">
                                    @for (
                                        block of managedPage.widgets | orderBy: ['data.row', 'data.col'];
                                        track trackByFn($index, block)
                                    ) {
                                        <core-block
                                            [block]="block"
                                            [class]="
                                                getBlockClasses(block) +
                                                ' ' +
                                                getBlockClassPosition(block, managedPage.widgets[$index - 1])
                                            "
                                            [ngStyle]="{ padding: block.data.padding, block: block.data.margin }">
                                        </core-block>
                                    }
                                </div>
                            }
                        } @else {
                            <core-block-card-shimmer></core-block-card-shimmer>
                        }
                    }
                }
            </div>
            <core-login-footer></core-login-footer>
        </div>
        <core-demo-config-toggle></core-demo-config-toggle>
    </div>
}
